import React from "react";
import "./PastEvents.css";
import { Link } from "react-router-dom";

const AaiifaEvent2023 = () => {
  const events = [
    {
      year: "2023",
      title: "Day 1 28-07-2023",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2023/day1-2023/9.webp",
      link: "/day-1-2023",
    },
    {
      year: "2023",
      title: "Day 2 29-07-2023",
      img: "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2023/day2-2023/28.jpg",
      link: "/day-2-2023",
    },
  ];

  return (
    <>
      
      <section className="past-events-section">
        <div className="past-events-container">
          <div className="past-events-header">
            <p className="past-events-subtitle">2023 Aaiifa Event</p>
          </div>

          <div className="past-events-grid">
  {events.map((event, index) => (
    <Link
      to={event.link}
      className="past-event-card"
      key={index}
    >
      <div className="past-event-image">
        <img src={event.img} alt={event.title} />
      </div>
      <div className="past-event-title-bar">
        <h3>{event.title}</h3>
      </div>
    </Link>
  ))}
</div>
        </div>
      </section>
    </>
  );
};

export default AaiifaEvent2023;
